import { createContext, useContext } from 'react';
import { ThemeShape } from '../types';

export const ThemeContext = createContext<ThemeShape>({} as ThemeShape);

export function useTheme<T extends ThemeShape>() {
  const theme = useContext(ThemeContext) as T;
  return theme;
}
